import { Type } from "class-transformer";
import { FrontendField } from "./FrontendField";

export class GenericObjectDefinition {
    scope: string;
    id: string;
    title: string;
    icon: string;
    nameSingular: string;
    namePlural: string;
    singleton = false;
    apiEndpoint: string;
    @Type(() => FrontendField)
    attributes: FrontendField[];
}
